import React from 'react'
import ReactDOM from 'react-dom/client'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import { TooltipProvider } from '@/components/ui/tooltip'
import { ThemeProvider } from '@/state/theme-context'
import { Toaster } from '@/components/ui/sonner'
import { registerSW } from 'virtual:pwa-register'
import './styles.css'

if (import.meta.env.PROD) {
  registerSW({
    immediate: true,
    onRegisteredSW(_url, registration) {
      if (!registration) return
      const checkForUpdate = () => {
        if (navigator.onLine) void registration.update().catch(() => { /* Retry on the next visit or focus. */ })
      }
      window.addEventListener('focus', checkForUpdate)
      window.setInterval(checkForUpdate, 60 * 60 * 1000)
      checkForUpdate()
    },
  })
}

const router = createRouter({ routeTree, defaultPreload: 'intent' })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <TooltipProvider delayDuration={350}>
        <RouterProvider router={router} />
        <Toaster position="top-center" />
      </TooltipProvider>
    </ThemeProvider>
  </React.StrictMode>,
)
